const BASE_API_URL = "https://payment-card.cloud.coinhouse.io"
export default BASE_API_URL